import { Product } from '../types'

export const products: Product[] = [
  {
    id: '1',
    name: 'Apple AirPods Pro (2nd Generation)',
    slug: 'apple-airpods-pro-2nd-gen',
    description:
      'The Apple AirPods Pro (2nd generation) deliver up to 2x more Active Noise Cancellation than the previous generation. Adaptive Transparency lets you hear the world around you while reducing loud environmental noise. Personalized Spatial Audio with dynamic head tracking places sound all around you.',
    shortDescription:
      'Active Noise Cancellation, Adaptive Transparency, Personalized Spatial Audio',
    price: 67999,
    originalPrice: 74999,
    discount: 9,
    images: [
      'https://images.unsplash.com/photo-1606220588913-b3aacb4d2f46?w=600',
      'https://images.unsplash.com/photo-1603351154351-5e2d0600bb77?w=600',
    ],
    category: 'Earbuds',
    categorySlug: 'earbuds',
    brand: 'Apple',
    rating: 4.8,
    reviewCount: 2456,
    inStock: true,
    stockQuantity: 45,
    specifications: {
      Chip: 'Apple H2',
      'Active Noise Cancellation': 'Yes',
      'Transparency Mode': 'Adaptive',
      'Battery Life': 'Up to 6 hours',
      'Charging Case': 'MagSafe, Lightning, Qi',
      'Water Resistance': 'IPX4',
    },
    features: [
      'Active Noise Cancellation',
      'Adaptive Transparency',
      'Personalized Spatial Audio',
      'Touch control',
      'MagSafe Charging Case',
    ],
    tags: ['wireless', 'noise-cancelling', 'premium'],
    sku: 'APP-AIRPODS-PRO2',
    createdAt: '2024-01-15',
  },
  {
    id: '2',
    name: 'Samsung Galaxy Buds2 Pro',
    slug: 'samsung-galaxy-buds2-pro',
    description:
      'Experience Hi-Fi sound quality with 24-bit audio and enhanced 360 Audio. Intelligent Active Noise Cancellation blocks out unwanted noise while you enjoy your favorite content.',
    shortDescription: 'Hi-Fi 24-bit audio, Intelligent ANC, 360 Audio',
    price: 42999,
    originalPrice: 49999,
    discount: 14,
    images: [
      'https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=600',
    ],
    category: 'Earbuds',
    categorySlug: 'earbuds',
    brand: 'Samsung',
    rating: 4.6,
    reviewCount: 1823,
    inStock: true,
    stockQuantity: 78,
    specifications: {
      Audio: '24-bit Hi-Fi',
      'Active Noise Cancellation': 'Intelligent ANC',
      'Battery Life': 'Up to 5 hours',
      Connectivity: 'Bluetooth 5.3',
      'Water Resistance': 'IPX7',
    },
    features: [
      '24-bit Hi-Fi audio',
      'Intelligent ANC',
      '360 Audio',
      'Voice Detect',
      'IPX7 water resistance',
    ],
    tags: ['wireless', 'samsung', 'premium'],
    sku: 'SAM-BUDS2-PRO',
    createdAt: '2024-01-20',
  },
  {
    id: '3',
    name: 'Xiaomi Power Bank 20000mAh 33W',
    slug: 'xiaomi-power-bank-20000mah',
    description:
      'High capacity 20000mAh power bank with 33W fast charging support. Charge your devices multiple times on a single charge. Features dual USB-A ports and USB-C port for versatile charging.',
    shortDescription: '20000mAh capacity, 33W fast charging, Triple output',
    price: 5999,
    originalPrice: 7499,
    discount: 20,
    images: [
      'https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=600',
    ],
    category: 'Power Banks',
    categorySlug: 'power-banks',
    brand: 'Xiaomi',
    rating: 4.5,
    reviewCount: 3421,
    inStock: true,
    stockQuantity: 156,
    specifications: {
      Capacity: '20000mAh',
      Input: 'USB-C 33W',
      Output: 'USB-A x2, USB-C',
      'Fast Charging': '33W Max',
      Weight: '434g',
    },
    features: [
      '20000mAh high capacity',
      '33W fast charging',
      'Triple output ports',
      'LED indicator',
      'Compact design',
    ],
    tags: ['power-bank', 'fast-charging', 'xiaomi'],
    sku: 'XIA-PB-20000',
    createdAt: '2024-02-01',
  },
  {
    id: '4',
    name: 'Apple Watch Series 9 GPS 45mm',
    slug: 'apple-watch-series-9-gps',
    description:
      'The most powerful Apple Watch yet with the new S9 chip. Features a brighter Always-On Retina display, Double Tap gesture, and advanced health monitoring including blood oxygen and ECG.',
    shortDescription: 'S9 chip, Always-On display, Advanced health features',
    price: 134999,
    originalPrice: 149999,
    discount: 10,
    images: ['https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=600'],
    category: 'Smart Watches',
    categorySlug: 'smart-watches',
    brand: 'Apple',
    rating: 4.9,
    reviewCount: 1567,
    inStock: true,
    stockQuantity: 23,
    specifications: {
      Chip: 'S9 SiP',
      Display: '45mm Always-On Retina',
      Storage: '64GB',
      'Water Resistance': '50m',
      Battery: 'Up to 18 hours',
    },
    features: [
      'S9 chip with Neural Engine',
      'Double Tap gesture',
      'Blood Oxygen monitoring',
      'ECG app',
      'Crash Detection',
    ],
    tags: ['smartwatch', 'apple', 'fitness'],
    sku: 'APP-WATCH-S9-45',
    createdAt: '2024-01-10',
  },
  {
    id: '5',
    name: 'Anker 65W GaN Charger',
    slug: 'anker-65w-gan-charger',
    description:
      'Ultra-compact 65W GaN charger with dual USB-C ports. Power your laptop and phone simultaneously. GaN technology delivers more power in a smaller size.',
    shortDescription: '65W GaN, Dual USB-C, Ultra-compact',
    price: 8999,
    originalPrice: 10999,
    discount: 18,
    images: [
      'https://images.unsplash.com/photo-1583863788434-e58a36330cf0?w=600',
    ],
    category: 'Chargers',
    categorySlug: 'chargers',
    brand: 'Anker',
    rating: 4.7,
    reviewCount: 2134,
    inStock: true,
    stockQuantity: 89,
    specifications: {
      'Total Power': '65W',
      Ports: 'USB-C x2',
      Technology: 'GaN II',
      Input: '100-240V',
      Size: '52 x 52 x 29mm',
    },
    features: [
      '65W total output',
      'GaN II technology',
      'Dual USB-C ports',
      'Foldable plug',
      'Universal compatibility',
    ],
    tags: ['charger', 'fast-charging', 'gan'],
    sku: 'ANK-65W-GAN',
    createdAt: '2024-02-05',
  },
  {
    id: '6',
    name: 'Logitech G502 HERO Gaming Mouse',
    slug: 'logitech-g502-hero-gaming-mouse',
    description:
      'High-performance gaming mouse with HERO 25K sensor, 11 programmable buttons, and adjustable weight system. RGB LIGHTSYNC technology with 16.8 million colors.',
    shortDescription: 'HERO 25K sensor, 11 buttons, RGB LIGHTSYNC',
    price: 12999,
    originalPrice: 15999,
    discount: 19,
    images: [
      'https://images.unsplash.com/photo-1527814050087-3793815479db?w=600',
    ],
    category: 'Gaming Accessories',
    categorySlug: 'gaming-accessories',
    brand: 'Logitech',
    rating: 4.8,
    reviewCount: 4521,
    inStock: true,
    stockQuantity: 67,
    specifications: {
      Sensor: 'HERO 25K',
      DPI: '100-25,600',
      Buttons: '11 Programmable',
      Weight: '121g (adjustable)',
      Connection: 'Wired USB',
    },
    features: [
      'HERO 25K sensor',
      '11 programmable buttons',
      'Adjustable weight system',
      'RGB LIGHTSYNC',
      'On-board memory',
    ],
    tags: ['gaming', 'mouse', 'rgb'],
    sku: 'LOG-G502-HERO',
    createdAt: '2024-01-25',
  },
  {
    id: '7',
    name: 'Samsung 25W Super Fast Charger',
    slug: 'samsung-25w-super-fast-charger',
    description:
      'Official Samsung 25W Super Fast Charger with USB-C to USB-C cable included. Compatible with all Samsung Galaxy devices and other USB-C devices.',
    shortDescription: '25W Super Fast Charging, USB-C, Cable included',
    price: 3499,
    originalPrice: 4499,
    discount: 22,
    images: [
      'https://images.unsplash.com/photo-1610792516307-ea5acd9c3b00?w=600',
    ],
    category: 'Chargers',
    categorySlug: 'chargers',
    brand: 'Samsung',
    rating: 4.6,
    reviewCount: 1876,
    inStock: true,
    stockQuantity: 234,
    specifications: {
      Power: '25W',
      Port: 'USB-C',
      Cable: 'USB-C to USB-C included',
      Input: '100-240V',
      Certification: 'PD 3.0',
    },
    features: [
      '25W Super Fast Charging',
      'USB-C cable included',
      'PD 3.0 certified',
      'Compact design',
      'Universal compatibility',
    ],
    tags: ['charger', 'samsung', 'fast-charging'],
    sku: 'SAM-25W-CHRG',
    createdAt: '2024-02-10',
  },
  {
    id: '8',
    name: 'JBL Tune 760NC Wireless Headphones',
    slug: 'jbl-tune-760nc-wireless-headphones',
    description:
      'Over-ear wireless headphones with Active Noise Cancelling. JBL Pure Bass sound, 50+ hours battery life, and multi-point connection for seamless device switching.',
    shortDescription: 'Active Noise Cancelling, 50h battery, JBL Pure Bass',
    price: 18999,
    originalPrice: 24999,
    discount: 24,
    images: [
      'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600',
    ],
    category: 'Earbuds',
    categorySlug: 'earbuds',
    brand: 'JBL',
    rating: 4.4,
    reviewCount: 2341,
    inStock: true,
    stockQuantity: 45,
    specifications: {
      Driver: '40mm',
      Battery: '50+ hours (ANC off)',
      ANC: 'Active Noise Cancelling',
      Connectivity: 'Bluetooth 5.0',
      Weight: '225g',
    },
    features: [
      'Active Noise Cancelling',
      'JBL Pure Bass sound',
      '50+ hours battery',
      'Multi-point connection',
      'Foldable design',
    ],
    tags: ['headphones', 'wireless', 'anc'],
    sku: 'JBL-TUNE-760NC',
    createdAt: '2024-01-30',
  },
  {
    id: '9',
    name: 'Baseus 100W USB-C Cable',
    slug: 'baseus-100w-usb-c-cable',
    description:
      'Premium braided USB-C to USB-C cable supporting 100W power delivery. Perfect for charging laptops, tablets, and phones. 2-meter length with durable nylon braiding.',
    shortDescription: '100W PD, 2m length, Braided nylon',
    price: 1499,
    originalPrice: 1999,
    discount: 25,
    images: ['https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600'],
    category: 'Mobile Accessories',
    categorySlug: 'mobile-accessories',
    brand: 'Baseus',
    rating: 4.5,
    reviewCount: 3567,
    inStock: true,
    stockQuantity: 456,
    specifications: {
      Power: '100W PD',
      Length: '2 meters',
      Material: 'Braided Nylon',
      'Data Transfer': '480Mbps',
      Connector: 'USB-C to USB-C',
    },
    features: [
      '100W Power Delivery',
      'Braided nylon construction',
      '2-meter length',
      'Universal compatibility',
      'Durable design',
    ],
    tags: ['cable', 'usb-c', 'fast-charging'],
    sku: 'BAS-100W-CABLE',
    createdAt: '2024-02-15',
  },
  {
    id: '10',
    name: 'Razer BlackShark V2 Gaming Headset',
    slug: 'razer-blackshark-v2-gaming-headset',
    description:
      'Esports gaming headset with THX Spatial Audio, 50mm TriForce Titanium drivers, and detachable HyperClear Cardioid mic. Ultra-lightweight at just 262g.',
    shortDescription: 'THX Spatial Audio, TriForce drivers, HyperClear mic',
    price: 24999,
    originalPrice: 29999,
    discount: 17,
    images: [
      'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=600',
    ],
    category: 'Gaming Accessories',
    categorySlug: 'gaming-accessories',
    brand: 'Razer',
    rating: 4.7,
    reviewCount: 1234,
    inStock: true,
    stockQuantity: 34,
    specifications: {
      Driver: '50mm TriForce Titanium',
      Audio: 'THX Spatial Audio',
      Microphone: 'HyperClear Cardioid',
      Weight: '262g',
      Connection: 'USB / 3.5mm',
    },
    features: [
      'THX Spatial Audio',
      'TriForce Titanium drivers',
      'HyperClear Cardioid mic',
      'Ultra-lightweight design',
      'Memory foam cushions',
    ],
    tags: ['gaming', 'headset', 'esports'],
    sku: 'RAZ-BSHARK-V2',
    createdAt: '2024-02-08',
  },
  {
    id: '11',
    name: 'Amazfit GTR 4 Smartwatch',
    slug: 'amazfit-gtr-4-smartwatch',
    description:
      'Premium smartwatch with AMOLED display, dual-band GPS, and 14-day battery life. Advanced health monitoring including heart rate, SpO2, and stress tracking.',
    shortDescription: 'AMOLED display, 14-day battery, Dual-band GPS',
    price: 44999,
    originalPrice: 54999,
    discount: 18,
    images: [
      'https://images.unsplash.com/photo-1579586337278-3befd40fd17a?w=600',
    ],
    category: 'Smart Watches',
    categorySlug: 'smart-watches',
    brand: 'Amazfit',
    rating: 4.5,
    reviewCount: 987,
    inStock: true,
    stockQuantity: 56,
    specifications: {
      Display: '1.43" AMOLED',
      Battery: '14 days typical',
      GPS: 'Dual-band',
      'Water Resistance': '5 ATM',
      Sensors: 'BioTracker 4.0',
    },
    features: [
      'AMOLED always-on display',
      '14-day battery life',
      'Dual-band GPS',
      '150+ sports modes',
      'Alexa built-in',
    ],
    tags: ['smartwatch', 'fitness', 'gps'],
    sku: 'AMZ-GTR4',
    createdAt: '2024-01-28',
  },
  {
    id: '12',
    name: 'Keychron K2 Mechanical Keyboard',
    slug: 'keychron-k2-mechanical-keyboard',
    description:
      'Compact 75% wireless mechanical keyboard with hot-swappable switches, RGB backlight, and Mac/Windows compatibility. Gateron switches for smooth typing.',
    shortDescription: '75% layout, Hot-swappable, RGB backlight',
    price: 19999,
    originalPrice: 24999,
    discount: 20,
    images: [
      'https://images.unsplash.com/photo-1595225476474-87563907a212?w=600',
    ],
    category: 'Computer Accessories',
    categorySlug: 'computer-accessories',
    brand: 'Keychron',
    rating: 4.6,
    reviewCount: 1567,
    inStock: true,
    stockQuantity: 28,
    specifications: {
      Layout: '75% (84 keys)',
      Switches: 'Gateron (Hot-swappable)',
      Backlight: 'RGB',
      Battery: '4000mAh',
      Connection: 'Bluetooth / USB-C',
    },
    features: [
      'Hot-swappable switches',
      'RGB backlight',
      'Mac/Windows compatible',
      'Bluetooth 5.1',
      'Aluminum frame',
    ],
    tags: ['keyboard', 'mechanical', 'wireless'],
    sku: 'KEY-K2-RGB',
    createdAt: '2024-02-12',
  },
]

export const featuredProducts = products.slice(0, 8)
export const bestSellers = products.filter((p) => p.reviewCount > 2000)
export const newArrivals = products.slice(-4)
export const dealsOfTheDay = products.filter((p) => (p.discount || 0) >= 20)
